"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CdAutocomplete = /** @class */ (function () {
    function CdAutocomplete() {
        this.changeTrigger = false;
    }
    return CdAutocomplete;
}());
exports.CdAutocomplete = CdAutocomplete;
